/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, RichText, withDatasourceCheck } from '@sitecore-content-sdk/nextjs';
/**
 * A simple Content Block component, with a heading and rich text block.
 */ const ContentBlock = ({ fields })=>/*#__PURE__*/ _jsxs("div", {
        className: "contentBlock",
        children: [
            /*#__PURE__*/ _jsx(Text, {
                tag: "h2",
                className: "contentTitle",
                field: fields.heading
            }),
            /*#__PURE__*/ _jsx(RichText, {
                className: "contentDescription",
                field: fields.content
            })
        ]
    });
export default withDatasourceCheck()(ContentBlock);
